import React, { useRef, useImperativeHandle, useEffect } from 'react'
import PropTypes from 'prop-types'

import { FieldContainer } from '@elparking/components'
import { Label } from './layout'
import StyledSelect from './StyledSelect'

const Select = React.forwardRef(({
    width,
    showLabel,
    label,
    forceFocus,
    options,
    value,
    dataTest,
    ...restProps
}, ref) => {
    const labelRef = useRef(null)

    function focus () {
        labelRef.current.scrollIntoView()
    }

    useEffect(() => {
        if (forceFocus) {
            focus()
        }
    }, [forceFocus])

    useImperativeHandle(ref, () => ({
        focus,
    }))

    return (
        <FieldContainer width={width} dataTest={dataTest}>
            {showLabel && <Label ref={labelRef}>
                {label}
            </Label>}
            <StyledSelect {...restProps} options={options} value={options && options.find(op => `${op.value}` === `${value}`)} />
        </FieldContainer>
    )
})

Select.propTypes = {
    width: PropTypes.string,
    showLabel: PropTypes.bool,
    label: PropTypes.node,
    forceFocus: PropTypes.bool,
    height: PropTypes.any,
    options: PropTypes.array,
    value: PropTypes.any,
    dataTest: PropTypes.string,
}

Select.defaultProps = {
    height: '36px',
    options: [],
}

export default Select
